import Breadcrumb from "@/components/Breadcrumb";
import Hero2 from "@/components/Hero2";
import OfficeListing from "@/components/OfficeListing";
import ContactHero from "@/components/ContactHero";
import SeoHead from "@/components/SeoHead";
import classes from "./styles.module.scss";
import { Global } from "@sourceflow-uk/sourceflow-sdk";
import SourceFlowText from "@sourceflow-uk/sourceflowtext";

import { offices_helper } from "@/helpers/offices_helper";
import { Cookies } from "@/components";

export default function ContactUsPage({ all_offices, global }) {
  const image = {
    path: "contact_us.contact_hero.image",
  };

  return (
    <>
      <div style={{ marginTop: "120px" }}>
        <SeoHead
          page_name={`Xcede Technology Recruitment Specialists | Contact Us`}
          canonical_link={`https://www.xcede.com/contact-us`}
        />
        <div className={classes.cont}>
          <Breadcrumb label="Contact Us" />
          <Hero2
            readMore={false}
            highlight="contact us"
            body="Have a question or need assistance? We're here to help! Select a city below to connect with our team of local experts."
          ></Hero2>
        </div>
        {/* <SourceFlowText global={global} path="four_oh_four.header" type="html">
          <h1 className="d-flex flex-column mb-5">
            <span className="wrapper">404</span>
            <span>Page Not Found</span>
          </h1>
        </SourceFlowText> */}
        <OfficeListing offices={all_offices} />
        <ContactHero
          dark={true}
          image={image}
          title="work for xcede"
          subtitle="We believe that unlocking the potential of our workforce through outstanding training, earning potential and reward structures is key to Xcede's success."
          description="We offer all our employees a world-class recruitment environment to support their career growth from trainee level to management and beyond. Our industry-leading incentives include everything from international travel experiences to exciting relocation opportunities across the globe. Find out more about life at Xcede"
          buttonLabel="Join Our Team"
          buttonLink="/join-us"
        />
      </div>
    </>
  );
}

export async function getStaticProps({}) {
  const global = (await Global()).toJson();
  const all_offices = offices_helper.fetch();

  return {
    props: {
      all_offices,
      global,
    },
  };
}
